// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3OkPl","footer":"ModalFilter_footer__8bCKx"};